export default "__VITE_ASSET__DW1z58jz__"